<template>
  <div :class="classes">
    <wo-icon icon="spinner" />
  </div>
</template>

<script>
export default {
  name: 'PoLoading',
  props: {
    modLayover: Boolean
  },
  computed: {
    classes () {
      return ['po-loading', {
        'po-loading--layover': this.modLayover
      }]
    }
  }
}
</script>
<style lang="scss">
.po-loading {
  &--layover {
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    top: 3em;

    .wo-icon {
      position: relative;
      left: 50%;
    }
  }
  .wo-icon {
    animation: spin 1.2s infinite linear;
    width: 2em;
    opacity: .3;

    .wo-icon__svg-icon {
      height: 2em;
      width: 2em;
    }
  }
}
</style>
